<template>
  <Head>
    <title>{{ $t('login') }} - {{ setting.brandShortName }}</title>
  </Head>
  <div>
    <div class="onboard-wrapper flex w-screen items-center justify-center overflow-hidden">        
      <SignIn
        :status="status"
        :is-modal-login="isModalLogin"
        @signup-page="signupPage"
      />
    </div>
  </div>
</template>

<script>

import SignIn from "@/components/Onboard/SignIn.vue";
import BlankLayout from "@/Layouts/BlankLayout.vue";
import Setting from '@/setting.js';
export default {
    components: {
        SignIn
    },
    layout: BlankLayout,
    props: {
        canResetPassword: Boolean,
        status: String,
        isModalLogin:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            setting: new Setting(),
        }
    },
    methods: {
        signupPage() {
            const queryParam = route().params;
            queryParam.mode = 'signup';
            this.$inertia.get(this.route('onboard'),queryParam)
        }
    }
}
</script>
<style scoped>
    .onboard-wrapper{
        height: 100vh;
    }
    @media (max-height: 620px) {
        .onboard-wrapper{
            align-items: start !important;
            overflow: auto !important;
            padding: 50px 0;
        }
    }
</style>